var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtomsIconFilledHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA362144-42C2-4BFE-B42A-BA3879B5AD38") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hub---Onboarding",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CL---Hub---Tutor-Pop-up",
    transform: "translate(-308.000000, -995.000000)",
    fill: "#FF6600"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Icon-/-Filled-/-Heart",
    transform: "translate(308.000000, 995.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7665981,23.3333333 L13.7665981,23.3333333 C13.4749449,23.3333333 13.1964491,23.2180392 12.9903182,23.0105098 L4.47426468,14.4677647 C2.24191177,12.2277647 2.24191177,8.58337255 4.47426468,6.34337255 C5.55206572,5.26290196 6.99169213,4.66666667 8.52561242,4.66666667 C10.0595327,4.66666667 11.4991591,5.26290196 12.5769602,6.34337255 L13.7665981,7.53694118 L14.9551397,6.34447059 C16.0340371,5.26290196 17.4736635,4.66666667 19.0075838,4.66666667 C20.5415041,4.66666667 21.9811305,5.26290196 23.0589316,6.34337255 C25.2912845,8.58337255 25.2912845,12.2277647 23.060028,14.4677647 L14.542878,23.0116078 C14.3367472,23.2180392 14.0582513,23.3333333 13.7665981,23.3333333",
    id: "\\uD83C\\uDFA8-Icon-\\u0421olor"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtomsIconFilledHeart);
export default __webpack_public_path__ + "static/media/atoms-icon-filled-heart.1f7fa89d1b580c83c901b0a2d86d9114.svg";
export { ForwardRef as ReactComponent };